import {OrderService} from './OrderService';

export type CurrentOrders = {returning?: OrderService; inProgress?: OrderService; draft?: OrderService};
